<template>
  <div>
    <el-form 
      role="form" 
      @submit.prevent.native="onSubmit">
      <div class="row">
        <div class="col-md-4">
          <base-input 
            label="Select Field">
            <el-select
              v-model="currentFilter"
              selected-filters:-
            >
              <el-option
                label="Product Name"
                value="name"
              />
              <el-option
                label="HSN"
                value="hsn"
              />
              <el-option
                label="Barcode"
                value="barcode"
              />
              <el-option 
                label="Attribute" 
                value="category"/>
          </el-select></base-input>
        </div>
        <div class="col-md-8">
          <div 
            v-if="currentFilter === 'category'" 
            class="row">
            <div class="col-md-6">
              <base-input label="Select Attribute">
                <el-select v-model="selectedAttribute">
                  <el-option 
                    v-for="(item, index) in attributes" 
                    :key="index"
                    :label="item.label"
                    :value="item.label"/>
                </el-select>
              </base-input>
            </div>
            <div class="col-md-6">
              <base-input 
                v-model="selectedValue" 
                label="Enter Attribute Value"/>
            </div>
          </div>
          <base-input 
            v-else
            v-model="selectedValue"
            selected-filters:-
            label="Value" 
            placeholder="Type Value"/>
        </div>
      </div>
      <base-button 
        type="primary" 
        native-type="submit">Apply</base-button>
    </el-form>
  </div>
</template>

<script>
import {Form, Select, Option, DatePicker} from 'element-ui';
import { mapGetters, mapActions } from 'vuex';
export default {
components: {
   [Select.name]: Select,
    [Option.name]: Option,
    [Form.name]: Form,
    [DatePicker.name] : DatePicker
},
data() {
  return {
    currentFilter: null,
    selectedValue: null,
    selectedAttribute : null
  }
},
computed:{
  ...mapGetters({
    attributes: "attribute/getAttributes"
  })
},

mounted() {
  this.getAttributes();
},
methods:{
  ...mapActions({
    getAttributes : "attribute/getAttributes"
  }),
  onSubmit() {
    if(this.currentFilter === 'category') {
      const query1 = {
        field : 'value',
        value : this.selectedValue,
        type : this.selectedAttribute //added type key because while removing this filter, we have to remove its resp attribute also
      }
      const query2 = {
        field : 'attribute',
        value : this.selectedAttribute,
        type : this.selectedValue //added type key because while removing this filter, we have to remove its resp value also
      }
      this.$emit('apply',[query1, query2]);
      this.currentFilter = '';
      this.selectedValue = '';
      return
    }
    this.$emit('apply',{
      field: this.currentFilter,
      value: this.selectedValue,
    });
    this.currentFilter = '';
    this.selectedValue = '';
  },
}
}
</script>

<style>

</style>